import type { ThunkMiddleware } from 'redux-thunk';
import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import type { AllActions } from './reducers/index';
import rootReducer from './reducers/index';
import type { RootState } from './reducers';

const store = createStore(rootReducer, applyMiddleware(thunk as ThunkMiddleware<RootState, AllActions>));

// Use throughout app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
